<template>
    <div>
        <div id="create-campaign">
            <div class="app-container mb-5" v-show="!$global.loading">

                <v-container>
                    <div class="page-title mb-3">
                        Duplication d'une Campagne de mise à jour
                    </div>

                    <v-text-field v-model="campaign.name"
                                  background-color="white"
                                  label="Nom de votre campagne"
                                  outlined>
                    </v-text-field>

                    <v-stepper @change="setCurrentStep" non-linear :value="currentStep">
                        <v-stepper-header>
                            <v-stepper-step editable step="1">
                                Sélection
                            </v-stepper-step>

                            <v-stepper-step editable step="2">
                                Prestataires ({{ emailsValid.length }})
                            </v-stepper-step>

                            <v-stepper-step editable step="3">
                                Informations
                            </v-stepper-step>

                            <v-stepper-step editable step="4">
                                Contenu de l'e-mail
                            </v-stepper-step>

                            <v-stepper-step editable step="5">
                                Options
                            </v-stepper-step>

                            <v-stepper-step editable step="6">
                                Finaliser
                            </v-stepper-step>
                        </v-stepper-header>

                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <filters></filters>
                            </v-stepper-content>

                            <v-stepper-content step="2">
                                <verification></verification>
                            </v-stepper-content>

                            <v-stepper-content step="3">
                                <information v-if="tabulations.length"
                                             :tabulations="tabulations"
                                             :select-all="true">
                                </information>
                            </v-stepper-content>

                            <v-stepper-content step="4">
                                <email v-if="providers.length"></email>
                            </v-stepper-content>

                            <v-stepper-content step="5">
                                <options :criterias="criterias" :is-revival="false"></options>
                            </v-stepper-content>

                            <v-stepper-content step="6">
                                <finalize :cmaj-name="campaign.name"
                                          :update-mode="false"
                                          :is-revival="false"
                                          :criterias="criterias">
                                </finalize>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
                </v-container>
            </div>
        </div>
    </div>
</template>

<script>
import Filters from "@/components/campaign/cmaj/stepers/Filters"
import { mapMutations, mapState } from "vuex"
import Verification from "./stepers/Verification"
import Information from "./stepers/Information"
import Email from "./stepers/Email"
import Finalize from "./stepers/Finalize"
import Options from "./stepers/Options"

export default {
    name: "DuplicateCampaign",
    components: { Finalize, Email, Information, Verification, Filters, Options },
    data() {
        return {
            cmajId: null,
            campaign: { name: null },
            tabulations: [],
            initialCmaj: null,
            criterias: []
        }
    },
    methods: {
        ...mapMutations("createCmaj", ["setCurrentStep", "setFirstPartMail", "setLastPartMail", "setSender",
            "resetState", "setSubject", "setSignature", "setMediaSuggestion", "setPeriodsConfig"]),
        getCmaj() {
            this.$global.loading = true

            this.$http.get("auth/campaigns/cmaj/providers/" + this.cmajId).then(res => {
                this.initialCmaj = res.body.data.cmaj

                this.initDefaultName()

                this.setSender(this.initialCmaj.sender)
                this.setSubject(this.initialCmaj.batches[0].email_subject)
                this.setFirstPartMail(this.initialCmaj.batches[0].email_part1)
                this.setLastPartMail(this.initialCmaj.batches[0].email_part2)
                this.setSignature(this.initialCmaj.sender.signature)
                this.setMediaSuggestion(this.initialCmaj.media_suggestion)
                this.setPeriodsConfig(this.initialCmaj.periods_config)

                this.$global.loading = false
            })
        },
        getFields() {
            this.$http.get("auth/campaigns/cmaj/referential/fields/" + this.cmajId).then(res => {
                this.tabulations = res.body.data.tabulations
            })
        },
        initDefaultName() {
            this.campaign.name = this.initialCmaj.name + " (copie)"
        },
        getInternalCriterias() {
            this.$http.get('auth/account/apidae-criterias').then(res => {
                this.criterias = res.body.data.criterias
            })
        },
    },
    computed: {
        ...mapState("account", ["senders"]),
        ...mapState("createCmaj", ["currentStep", "emailsValid", "providers"]),
    },
    created() {
        let hash = this.$route.params.hash
        this.cmajId = atob(hash)

        this.getCmaj()

        this.resetState()
        this.$store.dispatch("account/fetchContacts")
        this.getFields()
        this.getInternalCriterias()

        this.$store.dispatch("account/loadSenders")

        this.$store.dispatch("account/fetchCategories")
        this.$store.dispatch("account/fetchCommunes")
    },
}
</script>